import DOI from "./DOI";
import Item from "./Item";
import List from "./List";

export default {
  DOI,
  Item,
  List
};
